import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Crown, Sparkles } from "lucide-react";

export function ProFeatureGate({ title = "This is a Pro feature", description, features = [] }) {
  const navigate = useNavigate();
  return (
    <Card className="max-w-lg mx-auto border-accent/30 shadow-sm p-8 text-center" data-testid="pro-feature-gate">
      <div className="h-12 w-12 rounded-full bg-accent/10 flex items-center justify-center mx-auto mb-4">
        <Crown className="h-6 w-6 text-accent" strokeWidth={1.75} />
      </div>
      <h2 className="font-heading text-2xl font-bold tracking-tight">{title}</h2>
      {description && <p className="text-muted-foreground text-sm mt-2">{description}</p>}
      {features.length > 0 && (
        <ul className="mt-5 space-y-2 text-left max-w-xs mx-auto">
          {features.map((f) => (
            <li key={f} className="flex items-start gap-2 text-sm text-foreground">
              <Sparkles className="h-4 w-4 text-accent mt-0.5 shrink-0" strokeWidth={2} />{f}
            </li>
          ))}
        </ul>
      )}
      <Button className="mt-6 h-11 px-8 active:scale-[0.98] transition-transform" onClick={() => navigate("/billing")} data-testid="upgrade-to-pro-button">
        <Crown className="h-4 w-4 mr-1.5" strokeWidth={2} /> Upgrade to Pro
      </Button>
    </Card>
  );
}
